import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import AppLogo from "../assets/AppLogo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const companyLinks = [
    { name: "What we do", path: "/what-we-do" },
    { name: "Workflow", path: "/workflow" },
    { name: "History", path: "/history" },
  ];

  const serviceLinks = [
    { name: "Consolidated Cargo", path: "/services/consolidated-cargo" },
    { name: "Logistics", path: "/services/logistics" },
    { name: "Airfreight", path: "/services/airfreight" },
    { name: "Ocean Freight", path: "/services/ocean-freight" },
    { name: "Intermodal", path: "/services/intermodal" },
    { name: "Reefer Express", path: "/services/reefer-express" },
    {
      name: "Warehouse & Distribution",
      path: "/services/warehouse-distribution",
    },
    { name: "Customs Clearance", path: "/services/customs-clearance" },
    {
      name: "International Trade Compliance",
      path: "/services/trade-compliance",
    },
    { name: "Household Removals", path: "/services/household-removals" },
    { name: "Project Cargo", path: "/services/project-cargo" },
  ];

  const quickLinks = [
    { name: "Equipment", path: "/equipment" },
    { name: "Rate Request", path: "/rate-request" },
    { name: "Contact", path: "/contact" },
    { name: "Client Portal", path: "/login" },
    { name: "Track Shipment", path: "/track" },
  ];



  return (
    <TheFooter>
      <div className="footer-main">
        <div className="footer-grid">
          {/* Company Info & Logo */}
          <div className="footer-section brand-section">
            <div className="footer-logo">
              <Link to="/">
                <img src={AppLogo} alt="Freight Company Logo" />
              </Link>
            </div>
            <p className="company-description">
              Your trusted partner in global freight forwarding and logistics
              solutions. Delivering excellence through integrated supply chain
              management, air and ocean freight, warehousing, and customs
              brokerage services worldwide.
            </p>
            <div className="tagline">
              <span>Global Reach • Local Expertise • Reliable Delivery</span>
            </div>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div className="footer-section">
            <h4>Services</h4>
            <div className="services-wrapper">
              <ul className="two-columns">
                {serviceLinks.slice(0, 6).map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
              <ul className="two-columns">
                {serviceLinks.slice(6).map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="bottom-container">
          <div className="copyright">
            &copy; {currentYear} Freight Company. All rights reserved.
          </div>
          <div className="legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/cookies">Cookie Policy</Link>
            <Link to="/compliance">Compliance</Link>
          </div>
        </div>
      </div>
    </TheFooter>
  );
};

const TheFooter = styled.footer`
  background: #0b1e33;
  color: #ffffff;
  margin-top: auto;
  width: 100%;

  .footer-main {
    padding: 4rem 10rem 2rem;
    border-bottom: 1px solid rgba(212, 175, 55, 0.2);

    .footer-grid {
      display: grid;
      grid-template-columns: 1.5fr 0.8fr 1.5fr 0.8fr;
      gap: 2rem;
    }

    .footer-section {
      h4 {
        color: #d4af37;
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 1.5rem;
        position: relative;
        padding-bottom: 0.5rem;

        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 2px;
          background: #d4af37;
        }
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 0.75rem;

          a {
            color: #cbd5e0;
            text-decoration: none;
            font-size: 0.9rem;
            transition: all 0.3s ease;
            display: inline-block;

            &:hover {
              color: #d4af37;
              transform: translateX(5px);
            }
          }
        }
      }

      .services-wrapper {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
      }

      .two-columns {
        flex: 1;
        min-width: 120px;

        li {
          margin-bottom: 0.6rem;
        }
      }
    }

    .brand-section {
      .footer-logo {
        width: 12rem;
        margin-bottom: 1.5rem;

        img {
          width: 100%;
          height: auto;
          filter: brightness(0) invert(1);
        }
      }

      .company-description {
        color: #cbd5e0;
        font-size: 0.85rem;
        line-height: 1.6;
        margin-bottom: 1rem;
      }

      .tagline {
        span {
          color: #d4af37;
          font-size: 0.85rem;
          font-weight: 500;
          letter-spacing: 2px;
        }
      }
    }
  }

  .footer-bottom {
    padding: 1.5rem 10rem;
    background: rgba(0, 0, 0, 0.3);

    .bottom-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;

      .copyright {
        font-size: 0.8rem;
        color: #94a3b8;
      }

      .legal-links {
        display: flex;
        gap: 1.5rem;
        flex-wrap: wrap;

        a {
          color: #94a3b8;
          text-decoration: none;
          font-size: 0.8rem;
          transition: color 0.3s ease;

          &:hover {
            color: #d4af37;
          }
        }
      }

      
    }
  }

  /* Responsive Styles */
  @media screen and (max-width: 1366px) {
    .footer-main {
      padding: 3rem 5rem 2rem;
    }
    .footer-bottom {
      padding: 1.5rem 5rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .footer-main {
      padding: 3rem 3rem 2rem;

      .footer-grid {
        grid-template-columns: 1fr 1fr;
        gap: 2rem;
      }
    }
    .footer-bottom {
      padding: 1.5rem 3rem;
    }
  }

  @media screen and (max-width: 900px) {
    .footer-main {
      padding: 2.5rem 2rem;

      .footer-grid {
        grid-template-columns: 1fr;
        gap: 2rem;
      }

      .footer-section {
        .services-wrapper {
          flex-direction: column;
        }
      }
    }

    .footer-bottom {
      padding: 1.5rem 2rem;

      .bottom-container {
        flex-direction: column;
        text-align: center;

        .legal-links {
          justify-content: center;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .footer-main {
      padding: 2rem 1.5rem;
    }
    .footer-bottom {
      padding: 1rem 1.5rem;

      .bottom-container {
        .legal-links {
          gap: 1rem;
          flex-wrap: wrap;
          justify-content: center;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    .footer-main {
      padding: 1.5rem 1rem;
    }
    .footer-bottom {
      padding: 1rem 1rem;

      .bottom-container {
        .legal-links {
          gap: 0.8rem;

          a {
            font-size: 0.7rem;
          }
        }
      }
    }
  }
`;

export default Footer;
